export const WIZARD_TABS = [
  { id: "flows", label: "Flows" },
  { id: "ia", label: "IA" },
  { id: "routes", label: "Routes" },
  { id: "folders", label: "Folders" },
  { id: "shells", label: "Shells" },
  { id: "tech-stack", label: "Tech Stack" },
  { id: "configs", label: "Configs" },
];

export const ISSUES_TAB = { id: "issues", label: "Issues" };
